import { HeaderBackButton } from "@react-navigation/elements";
import React, { useState, useEffect, useCallback } from "react";
import { Image } from "react-native";

const backIcon = require("@assets/images/back-icon.png");

const renderBackImage = ({ tintColor }) => (
  <Image
    source={backIcon}
    style={{ width: 24, height: 24, tintColor: tintColor || "black" }}
    resizeMode="contain"
  />
);

const BackButton = (props) => {
  const {
    onPress = () => {},
    tintColor = "black",
    alwaysEnable = false,
  } = props;
  const [backPressed, setBackPressed] = useState(false);
  useEffect(() => {
    if (backPressed && typeof onPress === "function") {
      onPress();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backPressed]);
  const _onPress = useCallback(() => {
    setBackPressed(true);
  }, []);
  return (
    <HeaderBackButton
      disabled={alwaysEnable ? !alwaysEnable : backPressed}
      onPress={alwaysEnable ? onPress : _onPress}
      tintColor={tintColor}
      backImage={renderBackImage}
      displayMode="minimal"
    />
  );
};

export default BackButton;
